import Vue from 'vue/dist/vue.esm';
import axios from 'common/axios';
import CommentsList from 'components/events/comments/comments_list.vue';
import CommentForm from 'components/events/comments/comment_form.vue';

document.addEventListener('DOMContentLoaded', () => {
  const eventID = JSON.parse(document.getElementById('event-comments').dataset.eventId);
  const canComment = JSON.parse(document.getElementById('event-comments').dataset.policyComment);

  new Vue({
    el: '#event-comments',
    components: { CommentForm, CommentsList },
    data: {
      comments: [],
      totalCount: 0,
      page: 1,
      errorMessage: '',
      infiniteId: +new Date()
    },
    computed: {
      eventId: function () {
        return eventID;
      },
      canComment: function () {
        return canComment;
      },
      commentsPath: function () {
        return '/events/' + this.eventId + '/comments.json';
      }
    },
    created: function () {
      let self = this;
      axios.get(self.commentsPath).then(function (response) {
        const data = response.data;
        self.totalCount = data.comments_total_count;
      });
    },
    methods: {
      destoryCommentPath(id) {
        return '/events/' + this.eventId + '/comments/' + id + '.json';
      },
      infiniteLoad($state) {
        axios.get(this.commentsPath, {
          params: {
            format: 'json',
            page: this.page
          }
        }).then(({ data }) => {
          if (data.comments.length) {
            this.page += 1;
            this.comments.push(...data.comments);
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      },
      loadComments() {
        let self = this;

        axios.get(self.commentsPath).then(function (response) {
          const data = response.data;
          self.comments = data.comments;
          self.totalCount = data.comments_total_count;
          // NOTE: loadで1ページ目を取得しているので、infiniteHandlerで重複しないようにpageを2にする
          self.page = 2;
          self.infiniteId++;
        });
      },
      createComment: async function (data) {
        try {
          this.errorMessage = '';
          await axios.post(this.commentsPath, data);
          this.loadComments();
        } catch (e) {
          this.errorMessage = e.response.data.message;
        }
      },
      destoryComment: async function (data) {
        try {
          this.errorMessage = '';
          await axios.delete(this.destoryCommentPath(data.comment_id));
          this.loadComments();
        } catch (e) {
          this.errorMessage = e.response.data.message;
        }
      }
    },
    template: `
      <div>
        <comment-form
          :canComment="canComment"
          :errorMessage="errorMessage"
          @submit-comment-form='createComment'
        >
        </comment-form>
        <comments-list
          :comments='comments'
          :totalCount='totalCount'
          :infiniteId='infiniteId'
          @infinite-load='infiniteLoad'
          @destory-comment='destoryComment'
        >
        </comments-list>
      </div>
    `
  });
});
